import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './CardGroup.css';

const propTypes = {
  className: PropTypes.string,
  segmented: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
};

const defaultProps = {
  className: undefined,
  segmented: false,
  tag: 'div',
};

const CardGroup = ({ className, segmented, tag: Tag, ...other }) => {
  const classes = classNames(
    className,
    'apollo-card-group',
    segmented ? 'apollo-card-group-segmented' : '',
  );

  return <Tag {...other} className={classes} />;
};

CardGroup.propTypes = propTypes;
CardGroup.defaultProps = defaultProps;

export default CardGroup;
